import { z } from 'zod';

export const partnerUserLocationSchema = z.object({
  locationIdentifier: z.string(),
  organizationIdentifier: z.string(),
  locationType: z.string().optional(),
  locationName: z.string().optional(),
  addressLine1: z.string().optional(),
  addressLine2: z.string().optional(),
  city: z.string().optional(),
  stateProvince: z.string().optional(),
  postalCode: z.string().optional(),
  countryCode: z.string().optional(),
  sfdcLocationId: z.string().optional(),
  isPrimary: z.boolean().optional().default(false),
});

export const partnerUserSchema = z.object({
  email: z.string(),
  name: z.string(),
  user_id: z.string(),
  idpRoleName: z.string().optional(),
  given_name: z.string().optional(),
  family_name: z.string().optional(),
  email_verified: z.boolean().optional(),
  created_at: z.string().optional(),
  updated_at: z.string().optional(),
  locations: z.array(partnerUserLocationSchema).optional().default([]),
});

export const partnerUsersResponseSchema = z.object({
  data: z.array(partnerUserSchema),
});

export type PartnerUserValidated = z.infer<typeof partnerUserSchema>;
export type PartnerUsersResponseValidated = z.infer<typeof partnerUsersResponseSchema>;
